import React from 'react';
import { 
	number, 
	func, 
} from 'prop-types';
import Presenter from './Presenter';
import Container from './Container';

const NewItemForm = ({onAddItem,...props})=> (
	<Container 
		onAddItem={onAddItem}
		render={({...containerProps})=><Presenter 
			{...containerProps}
			{...props}
		/>}
	/>
);

NewItemForm.propTypes = {
	onAddItem : func,
	quizCount : number
};

export default NewItemForm;